<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-dark btn-with-shadow mr-2"
            data-toggle="modal"
            @click="openaddmodal"
          >
            {{ $t("add_employee") }}
          </button>

        </div>
      </div>
    </div>

    <user :data="userAndRoles.users" title="Employees" @action="getActionUser" />
    <user-modal
      v-if="userAndRoles.users.isUserModalActive"
      @close-modal="closeUserModal"
    />

    <manage-users-modal
      v-if="userAndRoles.users.isManageUsersModalActive"
      @close-modal="closeManageUserModal"
    />

    <app-delete-modal
      v-if="confirmation.isActive"
      :preloader="deleteLoader"
      :modal-id="confirmation.modalId"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
    <user-addmodal
      v-if="isAddModalActive"
      :selected-url="selectedUrl"
      :userUrl="userUrl"
      @close-modal="closeAddEditModal"
    />

    <template v-if="assignFormsModal">
      <app-modal
        :modal-id="assignFormsModalId"
        modal-alignment="top"
        modal-size="default"
        @close-modal="closeAssignFormsModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t('Assign Forms to Employee') }}</h5>
          <button
            type="button"
            class="close outline-none"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeAssignFormsModal"
          >
            <span><app-icon name="x"></app-icon></span>
          </button>
        </template>
        <template slot="body">
          <div v-if="fetchingForms" class="text-center p-5">
            <app-preloader />
          </div>
          <div v-else-if="availableForms.length > 0">
            <p>{{ $t('The following forms/contracts will be assigned to the employee:') }}</p>
            <ul class="list-group">
              <li
                v-for="form in availableForms"
                :key="form.id"
                class="list-group-item d-flex align-items-center"
              >
                <input
                  type="checkbox"
                  :value="form.form_revision_id"
                  v-model="selectedEmployeeForms"
                  :disabled="assignedFormIds.includes(form.id)"
                  class="mr-3"
                  :style="{ width: '18px', height: '18px', cursor: assignedFormIds.includes(form.id) ? 'not-allowed' : 'pointer' }"
                />
                <span :class="{ 'text-muted': assignedFormIds.includes(form.id) }">{{ form.title }}</span>
                <span v-if="assignedFormIds.includes(form.id)" class="badge badge-secondary ml-auto">{{ $t('Already assigned') }}</span>
              </li>
            </ul>
          </div>
          <div v-else class="text-center">
            <p class="text-danger">{{ $t('No employment forms found. Please add forms to employment contracts first then proceed next.') }}</p>
            <a href="/admin/documentlibrary/mydocument" class="btn btn-primary">{{ $t('Go to Document Library') }}</a>
          </div>
        </template>
        <template slot="footer">
          <button
            v-if="availableForms.length > 0"
            type="button"
            class="btn btn-success mr-2"
            :disabled="selectedEmployeeForms.length === 0"
            @click.prevent="assignFormsConfirmed"
          >
            {{ $t('Assign') }}
          </button>
          <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            @click="closeAssignFormsModal"
          >
            {{ $t('Cancel') }}
          </button>
        </template>
      </app-modal>
    </template>
  </div>
</template>

<script>
import AppLibrary from "../../../Helpers/AppLibrary";

import UserModal from "../UserRoles/Users/UserModal";
import UserInvitationModal from "../UserRoles/Users/UserInvitationModal";
import ManageUsersModal from "../UserRoles/Users/ManageUsersModal";
import User from "../UserRoles/Users/Index";

import RolesAddEditModal from "../UserRoles/Roles/RolesAddEditModal";
import Role from "../UserRoles/Roles/Index";

import { UserAndRoleMixin } from "../UserRoles/Mixins/UserAndRoleMixin";

import * as actions from "../../../Config/ApiUrl";
import { GET_SCREENING_FORMS, GET_ASSIGNED_SCREENING_FORMS, ADD_TO_EMPLOYMENT } from "../../../Config/ScreeningAppUrl";
import { axiosGet, axiosPost } from "../../../Helpers/AxiosHelper";

import UserAddModal from "../UserRoles/Users/UserAddModal";

export default {
  name: "Employees",
  extends: AppLibrary,
  mixins: [UserAndRoleMixin],
  components: {
    UserModal,
    UserInvitationModal,
    RolesAddEditModal,
    User,
    ManageUsersModal,
    Role,
    UserAddModal,
  },
  data() {
    return {
      isAddModalActive: false,
      deleteLoader: false,
      rowData: {},
      selectedUrl: "",
      manage: false,
      userUrl: "",
      confirmation: {
        modalId: "confirmation-Modal",
        isActive: false,
        url: "",
        tableId: "",
      },
      assignFormsModal: false,
      assignFormsModalId: "assign_forms_to_employee_modal",
      selectedEmployee: {},
      availableForms: [],
      selectedEmployeeForms: [],
      assignedFormIds: [],
      fetchingForms: false,
    };
  },
  created() {
    this.$store.dispatch("getPermissions");
  },
  methods: {
    /* *
     * $EMIT FROM USER TABLE
     * */
    openaddmodal() {
      this.isAddModalActive = true;
    },
    closeAddEditModal() {
      $("#useraddmodal").modal("hide");
      this.isAddModalActive = false;
    },
    getActionUser(rowData, actionObj, active) {
      console.log("User-data", rowData)
      this.$store.dispatch("setRowData", rowData);

      if (actionObj.title == this.$t("assign_forms")) {
        this.openAssignFormsModal(rowData);
      } else if (actionObj.title == this.$t("manage_role")) {
        this.selectedUrl = `${actions.INVITE_USER}/${rowData.id}`;
        this.operationForUserInvitation();
      } else if (actionObj.title == this.$t("delete")) {
        this.confirmation.url = `${actions.USERS}/${rowData.id}`;
        this.confirmation.tableId = this.userAndRoles.users.tableId;
        this.openConfirmationModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.UPDATE_USER_NAME}/${rowData.id}`;
        this.openUserModal();
      } else if (actionObj.title == this.$t("active")) {
        this.changeUserStatus(1, rowData.id);
      } else if (actionObj.title == this.$t("de_activate")) {
        this.changeUserStatus(2, rowData.id);
      }
    },

    /* *
     * $EMIT FROM ROLE TABLE
     * */
    getActionRole(rowData, actionObj, active) {
      this.$store.dispatch("setRowData", rowData);
      this.manage = false;
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.ROLES}/${rowData.id}`;
        this.operateRoles(true);
      } else if (actionObj.title == this.$t("delete")) {
        this.confirmation.url = `${actions.ROLES}/${rowData.id}`;
        this.confirmation.tableId = this.userAndRoles.roles.tableId;
        this.openConfirmationModal();
      } else if (actionObj.title == this.$t("manage_users")) {
        this.operationForManageUser();
      } else if (actionObj.title == this.$t("permission")) {
        (this.manage = true),
          (this.selectedUrl = `${actions.ROLES}/${rowData.id}`);
        this.operateRoles(true, "manage_permission");
      }
    },

    /* *
     * OPERATION FOR ROLES
     * */
    operateRoles(isActive, title = "role") {
      const obj = {
        isActive: isActive,
        title: title,
      };
      this.$store.dispatch("operateRoles", obj);
    },

    /* *
     * CLOSE ROLE ADD EDIT MODAL
     * */
    closeModalRoleAddEditModal() {
      $("#" + this.userAndRoles.roles.addEditModalId).modal("hide");
      this.operateRoles(false);
      this.resetData();
    },

    /* *
     * OPEN MANAGE USER MODAL
     * */
    operationForManageUser(isActive = true) {
      this.$store.dispatch("operationForManageUser", isActive);
    },

    closeManageUserModal() {
      $("#" + this.userAndRoles.users.manageUserModalId).modal("hide");
      this.operationForManageUser(false);
      this.resetData();
    },

    /* *
     * OPEN INVITE MODAL
     * */
    operationForUserInvitation(isActive = true) {
      this.$store.dispatch("operationForUserInvitation", isActive);
    },

    /**
     * Open user modal
     * */
    openUserModal(isActive = true) {
      this.$store.dispatch("openUserModal", isActive);
    },
    /**
     * Close user modal
     * */
    closeUserModal() {
      
      $("#" + this.userAndRoles.users.userModalId).modal("hide");
      this.openUserModal(false);
      this.resetData();
    },

    /**
     * CLOSE INVITE MODAL
     * */
    closeInviteModal() {
      $("#" + this.userAndRoles.users.inviteModalId).modal("hide");
      this.operationForUserInvitation(false);
      this.resetData();
    },

    /**
     * Change user status
     * */
    changeUserStatus(status, id) {
      let url = `${actions.USERS_LIST}/${id}`,
        reqData = this.userAndRoles.rowData;

      reqData.status_id = status;

      this.axiosPatch({
        url: url,
        data: reqData,
      })
        .then((res) => {
          this.$toastr.s(res.data.message);
          this.reLoadTable();
        })
        .catch((error) => {
          let { message } = error.response.data;
          this.$toastr.e(message);
        })
        .finally(() => {
          this.resetData();
        });
    },

    /* *
     * OPEN CONFIRMATION MODAL
     * */
    openConfirmationModal() {
      this.confirmation.isActive = true;
    },

    /* *
     * AFTER CONFIRMED FROM CONFIRMATION MODAL
     * */
    confirmed() {
      let url = this.confirmation.url;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          let { message } = error.response.data;
          this.$toastr.e(message);
        })
        .finally(() => {
          this.deleteLoader = false;
          $("#" + this.confirmation.modalId).modal("hide");
          this.cancelled();
          this.reLoadTable();
        });
    },

    /* *
     * AFTER CANCELLED FROM CONFIRMATION MODAL
     * */
    cancelled() {
      this.confirmation.isActive = false;
      this.resetData();
    },

    /* *
     * RESET DATA
     * */
    resetData() {
      this.$store.dispatch("setRowData", {});
      this.selectedUrl = "";
    },

    openAssignFormsModal(employee) {
      this.selectedEmployee = employee;
      this.availableForms = [];
      this.selectedEmployeeForms = [];
      this.assignedFormIds = [];
      this.fetchingForms = true;
      this.assignFormsModal = true;

      Promise.all([
        axiosGet(GET_SCREENING_FORMS),
        axiosGet(GET_ASSIGNED_SCREENING_FORMS + '?user_id=' + employee.id),
      ])
        .then(([formsRes, assignedRes]) => {
          this.availableForms = formsRes.data;
          this.assignedFormIds = (assignedRes.data.forms || []).map(f => f.id);
          this.selectedEmployeeForms = this.availableForms
            .filter(f => !this.assignedFormIds.includes(f.id))
            .map(f => f.form_revision_id);
        })
        .catch((error) => {
          const message = error.response?.data?.message || 'Failed to fetch forms.';
          this.$toastr.e(message);
        })
        .finally(() => {
          this.fetchingForms = false;
        });
    },

    assignFormsConfirmed() {
      const formsToAssign = this.selectedEmployeeForms.filter(revId => {
        const form = this.availableForms.find(f => f.form_revision_id === revId);
        return !form || !this.assignedFormIds.includes(form.id);
      });
      if (formsToAssign.length === 0) {
        this.$toastr.w(this.$t('Please select at least one form to assign'));
        return;
      }

      axiosPost(ADD_TO_EMPLOYMENT, {
        user_id: this.selectedEmployee.id,
        company_id: this.selectedEmployee.company_id,
        selected_forms: formsToAssign,
      })
        .then((response) => {
          this.$toastr.s(response.data.message);
          this.closeAssignFormsModal();
        })
        .catch((err) => {
          this.$toastr.e(err.response?.data?.message || 'Failed to assign forms.');
        });
    },

    closeAssignFormsModal() {
      $(`#${this.assignFormsModalId}`).modal('hide');
      this.assignFormsModal = false;
    },
  },
  mounted() {
    this.userUrl = this.$hub.$emit("reload-" + this.userAndRoles.users.tableId);
    
  },
};
</script>
